<template>
  <v-row no-gutters
    align="start"
    justify="center"
    class="control-toolbar pl-12 secondary">
    <!-- Checkbox for selecting rows. Button on toolbar should select/deselect all. -->
    <v-tooltip right>
      <template v-slot:activator="{on}">
        <v-checkbox
          class="select-all-checkbox small-checkbox"
          :value="multiviewAllExamsSelected"
          :color="colorHex"
          primary
          hide-details
          v-on="on"
          @click.stop="selectAllExamsMultiview"/>
      </template>
      <span>Select/Deselect All Exams</span>
    </v-tooltip>
    <od-os-ou-buttons :eye="multiviewEye" @selectEye="selectEyeMultiview" />
    <select-with-button
      multiple
      show-select-all
      collapsed-when-multiple
      selection-prefix="VIEW:"
      :value="deviceFilter"
      :items="deviceList"
      @change="selectDevicesMultiview"
      @input="selectDevicesMultiview"
      @selectAll="selectAllDevicesMultiview"
      item-text="procedure"
      item-value="devSrNo"
      button-slot="prepend"
      label="Select Devices"
      item-name="Device"
      class="toolbar-select"
      :class="colorClass"/>
    <select-with-button
      multiple
      show-select-all
      collapsed-when-multiple
      selection-prefix="VIEW:"
      :value="dateFilter"
      :items="dateList"
      @change="selectDatesMultiview"
      @input="selectDatesMultiview"
      @selectAll="selectAllDatesMultiview"
      button-slot="prepend"
      label="Select Dates"
      item-name="Date"
      class="toolbar-select"
      :class="colorClass"/>
    <!-- Circular buttons  for other options -->
    <avatar-button 
      class="inline-flex-for-overlay"
      @click="refreshMultiview" 
      :image="coloredAssetUrls.refresh">Refresh</avatar-button>
    <avatar-button
      class="inline-flex-for-overlay"
      @click="cancelAddImagesToOverlay"
      :image="coloredAssetUrls.close">Cancel</avatar-button>
    <avatar-button
      class="inline-flex-for-overlay"
      @click="openOverlay(selectedMultiviewImages)"
      :image="coloredAssetUrls.returnToOverlay">Register Selected Image(s) and Return to Overlay</avatar-button>
    <avatar-button
      class="hidden-for-overlay"
      @click="openProofsheet(selectedMultiviewImages)"
      :image="coloredAssetUrls.proofsheet">ProofSheet</avatar-button>
    <avatar-button
      class="float-right-for-overlay"
      @click="$emit('manualUpload')"
      :image="coloredAssetUrls.manualUpload"
      v-if="(!ssoEmrPro || enableSavingWithEmrPro) && !userIsViewOnly">Manual Upload</avatar-button>
    <avatar-button
      class="hidden-for-overlay"
      @click="openStereo(selectedMultiviewImages)"
      :image="coloredAssetUrls.stereo">Stereo</avatar-button>
    <avatar-button
      class="hidden-for-overlay"
      @click="openSideBySide(selectedMultiviewImages)"
      :image="coloredAssetUrls.sideBySide">Side by Side</avatar-button>
    <avatar-button
      class="hidden-for-overlay"
      @click="openMontage(selectedMultiviewImages)"
      :image="coloredAssetUrls.montage">Montage</avatar-button>
    <avatar-button
      class="hidden-for-overlay"
      @click="openOverlay(selectedMultiviewImages)"
      :image="coloredAssetUrls.overlay">Overlay</avatar-button>
    <avatar-button
      v-if="!userIsViewOnly"
      class="hidden-for-overlay"
      @click="openPrintPreview(selectedMultiviewImages)"
      :image="coloredAssetUrls.printButton">Print</avatar-button>
    <avatar-button
      v-if="!userIsViewOnly"
      @click="toggleMultiviewCollapse"
      :image="collapseIcon">{{collapseText}}</avatar-button>
  </v-row>
</template>

<script>
import selectWithButton from "../controls/SelectWithButton";
import avatarButton from "../controls/AvatarButton";
import odOsOuButtons from "../imageBrowser/controls/OdOsOuButtons";
import { mapGetters, mapActions, mapMutations } from "vuex";
export default {
  name: "patientExamMultiviewBrowserToolbar",
  components: { selectWithButton, odOsOuButtons, avatarButton },
  computed: {
    ...mapGetters([
      "patient",
      "ptSrNo",
      "eyeGroups",
      "currentGroup",
      "patientExamMultiviewContext",
      "multiviewEye",
      "exams",
      "deviceList",
      "deviceFilter",
      "multiviewAllExamsSelected",
      "dateList",
      "dateFilter",
      "selectedMultiviewImages",
      "ssoEmrPro",
      "userIsViewOnly",
      "enableSavingWithEmrPro",
      "multiviewIsCollapsed"
    ]),
    collapseText() {
      if (this.multiviewIsCollapsed)
        return "Expand";
      return "Collapse";
    },
    collapseIcon() {
      if (!this.multiviewIsCollapsed)
        return this.coloredAssetUrls.minimize;
      return this.coloredAssetUrls.expand;
    }
  },
  methods: {
    ...mapActions([
      "openOverlay",
      "openMontage",
      "cancelAddImagesToOverlay",
      "openProofsheet",
      "selectAllExamsMultiview",
      "refreshMultiview",
      "selectEyeMultiview",
      "selectDevicesMultiview",
      "selectAllDevicesMultiview",
      "selectDatesMultiview",
      "selectAllDatesMultiview",
      "openStereo",
      "openSideBySide",
      "openPrintPreview"
    ]),
    ...mapMutations(["toggleMultiviewCollapse"])
  }
};
</script>
